"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalManagerContext = void 0;
var _react = _interopRequireDefault(require("react"));
const ModalManagerContext = exports.ModalManagerContext = /*#__PURE__*/_react.default.createContext();
var _default = exports.default = ModalManagerContext;